import SalviaLayout from "@/components/SalviaLayout";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Download, Printer, ArrowLeft, FileText, CheckCircle2, AlertTriangle, Building2, Calendar, User } from "lucide-react";
import { useLocation, useParams } from "wouter";

export default function Document() {
  const params = useParams();
  const [, setLocation] = useLocation();

  return (
    <SalviaLayout title="Inventario de Riscos Psicossociais">
      <div className="max-w-5xl mx-auto space-y-6">
        {/* Header Actions */}
        <div className="flex items-center justify-between">
          <Button variant="outline" onClick={() => setLocation(`/result/${params.id}`)}>
            <ArrowLeft size={20} className="mr-2" />
            Voltar ao Resultado
          </Button>
          <div className="flex gap-2">
            <Button variant="outline">
              <Printer size={20} className="mr-2" />
              Imprimir
            </Button>
            <Button className="bg-[#C0FF00] hover:bg-[#a8e600] text-[#002F59]">
              <Download size={20} className="mr-2" />
              Baixar PDF
            </Button>
          </div>
        </div>

        {/* Document Preview */}
        <Card className="p-0 overflow-hidden shadow-xl">
          {/* Document Header */}
          <div className="bg-[#002F59] text-white p-8">
            <div className="flex items-start justify-between">
              <div className="flex items-center gap-4">
                <div className="w-16 h-16 bg-[#C0FF00] rounded-lg flex items-center justify-center">
                  <span className="text-[#002F59] font-bold text-xl">SI</span>
                </div>
                <div>
                  <h1 className="text-2xl font-bold">INSIGHT NR1</h1>
                  <p className="text-sm text-gray-300">Gestao de Riscos Psicossociais</p>
                </div>
              </div>
              <div className="text-right">
                <p className="text-sm text-gray-300">Documento</p>
                <p className="text-lg font-bold">INV-2026-00142</p>
              </div>
            </div>
          </div>

          {/* Document Title */}
          <div className="bg-gray-100 p-6 border-b">
            <h2 className="text-2xl font-bold text-[#002F59] text-center">
              INVENTARIO DE RISCOS PSICOSSOCIAIS
            </h2>
            <p className="text-center text-gray-600 mt-2">
              Conforme NR-01 (Gerenciamento de Riscos Ocupacionais) e NR-17 (Ergonomia)
            </p>
          </div>

          {/* Document Content */}
          <div className="p-8 space-y-8">
            {/* Company Info */}
            <section>
              <h3 className="text-lg font-bold text-[#002F59] border-b-2 border-[#002F59] pb-2 mb-4">
                1. IDENTIFICACAO DA EMPRESA
              </h3>
              <div className="grid grid-cols-2 gap-4">
                <div className="space-y-3">
                  <div className="flex items-center gap-2">
                    <Building2 size={18} className="text-[#002F59]" />
                    <div>
                      <p className="text-xs text-gray-500">Razao Social</p>
                      <p className="font-semibold">Tech Solutions LTDA</p>
                    </div>
                  </div>
                  <div>
                    <p className="text-xs text-gray-500">CNPJ</p>
                    <p className="font-semibold">22.333.444/0001-55</p>
                  </div>
                  <div>
                    <p className="text-xs text-gray-500">CNAE</p>
                    <p className="font-semibold">6201-5 - Desenvolvimento de programas de computador</p>
                  </div>
                </div>
                <div className="space-y-3">
                  <div>
                    <p className="text-xs text-gray-500">Endereco</p>
                    <p className="font-semibold">Av. Paulista, 1000 - Bela Vista</p>
                    <p className="text-sm text-gray-600">Sao Paulo - SP, CEP 01310-100</p>
                  </div>
                  <div>
                    <p className="text-xs text-gray-500">Grau de Risco</p>
                    <p className="font-semibold">2</p>
                  </div>
                </div>
              </div>
            </section>

            {/* Position Info */}
            <section>
              <h3 className="text-lg font-bold text-[#002F59] border-b-2 border-[#002F59] pb-2 mb-4">
                2. IDENTIFICACAO DO CARGO/FUNCAO
              </h3>
              <div className="grid grid-cols-2 gap-4">
                <div className="space-y-3">
                  <div>
                    <p className="text-xs text-gray-500">Cargo</p>
                    <p className="font-semibold">Desenvolvedor de Software</p>
                  </div>
                  <div>
                    <p className="text-xs text-gray-500">Setor</p>
                    <p className="font-semibold">Tecnologia da Informacao</p>
                  </div>
                  <div>
                    <p className="text-xs text-gray-500">Numero de Funcionarios</p>
                    <p className="font-semibold">5</p>
                  </div>
                </div>
                <div className="space-y-3">
                  <div>
                    <p className="text-xs text-gray-500">Data da Avaliacao</p>
                    <p className="font-semibold">13 de Janeiro de 2026</p>
                  </div>
                  <div>
                    <p className="text-xs text-gray-500">Responsavel Tecnico</p>
                    <p className="font-semibold">Dr. Carlos Silva - CRM 12345</p>
                  </div>
                </div>
              </div>
            </section>

            {/* Task Description */}
            <section>
              <h3 className="text-lg font-bold text-[#002F59] border-b-2 border-[#002F59] pb-2 mb-4">
                3. DESCRICAO DAS ATIVIDADES
              </h3>
              <div className="bg-gray-50 p-4 rounded-lg">
                <p className="text-gray-700 leading-relaxed">
                  Desenvolvimento e manutencao de sistemas de software, incluindo analise de requisitos, 
                  codificacao, testes e documentacao. Participacao em reunioes de equipe e alinhamento 
                  com stakeholders. Resolucao de problemas tecnicos e suporte a usuarios internos. 
                  Trabalho predominantemente em ambiente de escritorio com uso intensivo de computador.
                </p>
              </div>
            </section>

            {/* Methodology */}
            <section>
              <h3 className="text-lg font-bold text-[#002F59] border-b-2 border-[#002F59] pb-2 mb-4">
                4. METODOLOGIA APLICADA
              </h3>
              <div className="space-y-4">
                <p className="text-gray-700">
                  A avaliacao foi realizada utilizando o <strong>Questionario ERGOS</strong>, metodologia 
                  validada para analise de carga mental de trabalho, contemplando as seguintes dimensoes:
                </p>
                <div className="grid grid-cols-2 gap-4">
                  <div className="bg-blue-50 p-4 rounded-lg">
                    <h4 className="font-bold text-blue-800 mb-2">Grupo A - Exigencias Cognitivas</h4>
                    <ul className="text-sm text-gray-700 space-y-1">
                      <li>• Pressao de Tempo</li>
                      <li>• Atencao e Concentracao</li>
                      <li>• Complexidade das Tarefas</li>
                      <li>• Monotonia e Repetitividade</li>
                      <li>• Raciocinio e Decisao</li>
                    </ul>
                  </div>
                  <div className="bg-purple-50 p-4 rounded-lg">
                    <h4 className="font-bold text-purple-800 mb-2">Grupo B - Fatores Organizacionais</h4>
                    <ul className="text-sm text-gray-700 space-y-1">
                      <li>• Iniciativa e Autonomia</li>
                      <li>• Isolamento Social</li>
                      <li>• Horarios e Turnos</li>
                      <li>• Relacionamento Interpessoal</li>
                      <li>• Demandas Gerais</li>
                    </ul>
                  </div>
                </div>
              </div>
            </section>

            {/* Results */}
            <section>
              <h3 className="text-lg font-bold text-[#002F59] border-b-2 border-[#002F59] pb-2 mb-4">
                5. RESULTADOS DA AVALIACAO
              </h3>
              <div className="grid grid-cols-3 gap-4 mb-6">
                <div className="bg-[#002F59] text-white p-4 rounded-lg text-center">
                  <p className="text-sm text-gray-300">Carga Mental</p>
                  <p className="text-3xl font-bold text-[#C0FF00]">47.3</p>
                  <p className="text-xs text-gray-300">pontos</p>
                </div>
                <div className="bg-orange-100 p-4 rounded-lg text-center">
                  <p className="text-sm text-gray-600">Qualificador</p>
                  <p className="text-2xl font-bold text-orange-600">Alta</p>
                </div>
                <div className="bg-orange-100 p-4 rounded-lg text-center">
                  <p className="text-sm text-gray-600">Nivel de Risco</p>
                  <p className="text-2xl font-bold text-orange-600">Incerto</p>
                  <p className="text-xs text-gray-600">P=3 x S=4 = 12</p>
                </div>
              </div>

              <table className="w-full text-sm border-collapse">
                <thead>
                  <tr className="bg-[#002F59] text-white">
                    <th className="p-3 text-left">Dimensao</th>
                    <th className="p-3 text-center">Pontuacao</th>
                    <th className="p-3 text-center">Classificacao</th>
                  </tr>
                </thead>
                <tbody>
                  {[
                    { name: "Pressao de Tempo", score: "7/10", status: "Alto" },
                    { name: "Atencao e Concentracao", score: "8/10", status: "Critico" },
                    { name: "Complexidade das Tarefas", score: "6/10", status: "Moderado" },
                    { name: "Monotonia e Repetitividade", score: "4/10", status: "Baixo" },
                    { name: "Raciocinio e Decisao", score: "7/10", status: "Alto" },
                    { name: "Iniciativa e Autonomia", score: "5/10", status: "Moderado" },
                    { name: "Isolamento Social", score: "3/10", status: "Baixo" },
                    { name: "Horarios e Turnos", score: "6/10", status: "Moderado" },
                    { name: "Relacionamento Interpessoal", score: "4/10", status: "Baixo" },
                    { name: "Demandas Gerais", score: "7/10", status: "Alto" },
                  ].map((row, index) => (
                    <tr key={index} className={index % 2 === 0 ? "bg-gray-50" : "bg-white"}>
                      <td className="p-3 border">{row.name}</td>
                      <td className="p-3 border text-center font-semibold">{row.score}</td>
                      <td className="p-3 border text-center">
                        <span className={`px-2 py-1 rounded text-xs font-semibold ${
                          row.status === "Critico" ? "bg-red-100 text-red-800" :
                          row.status === "Alto" ? "bg-orange-100 text-orange-800" :
                          row.status === "Moderado" ? "bg-yellow-100 text-yellow-800" :
                          "bg-green-100 text-green-800"
                        }`}>
                          {row.status}
                        </span>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </section>

            {/* Action Plan */}
            <section>
              <h3 className="text-lg font-bold text-[#002F59] border-b-2 border-[#002F59] pb-2 mb-4">
                6. PLANO DE ACAO
              </h3>
              <table className="w-full text-sm border-collapse">
                <thead>
                  <tr className="bg-[#002F59] text-white">
                    <th className="p-3 text-left">Risco Identificado</th>
                    <th className="p-3 text-left">Acao Recomendada</th>
                    <th className="p-3 text-center">Prazo</th>
                    <th className="p-3 text-center">Prioridade</th>
                  </tr>
                </thead>
                <tbody>
                  <tr className="bg-red-50">
                    <td className="p-3 border">Alta demanda de atencao</td>
                    <td className="p-3 border">Implementar pausas programadas a cada 2 horas</td>
                    <td className="p-3 border text-center">30 dias</td>
                    <td className="p-3 border text-center">
                      <span className="px-2 py-1 bg-red-100 text-red-800 rounded text-xs font-semibold">Urgente</span>
                    </td>
                  </tr>
                  <tr className="bg-orange-50">
                    <td className="p-3 border">Pressao por prazos</td>
                    <td className="p-3 border">Revisar metodologia de estimativas de projetos</td>
                    <td className="p-3 border text-center">60 dias</td>
                    <td className="p-3 border text-center">
                      <span className="px-2 py-1 bg-orange-100 text-orange-800 rounded text-xs font-semibold">Alta</span>
                    </td>
                  </tr>
                  <tr className="bg-yellow-50">
                    <td className="p-3 border">Carga de decisoes</td>
                    <td className="p-3 border">Criar protocolos de decisao para situacoes recorrentes</td>
                    <td className="p-3 border text-center">90 dias</td>
                    <td className="p-3 border text-center">
                      <span className="px-2 py-1 bg-yellow-100 text-yellow-800 rounded text-xs font-semibold">Media</span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </section>

            {/* Signatures */}
            <section className="mt-12 pt-8 border-t-2">
              <div className="grid grid-cols-2 gap-8">
                <div className="text-center">
                  <div className="border-b-2 border-gray-400 mb-2 h-16"></div>
                  <p className="font-semibold">Responsavel Tecnico</p>
                  <p className="text-sm text-gray-600">Dr. Carlos Silva - CRM 12345</p>
                </div>
                <div className="text-center">
                  <div className="border-b-2 border-gray-400 mb-2 h-16"></div>
                  <p className="font-semibold">Responsavel pela Empresa</p>
                  <p className="text-sm text-gray-600">Tech Solutions LTDA</p>
                </div>
              </div>
            </section>
          </div>

          {/* Document Footer */}
          <div className="bg-gray-100 p-4 text-center text-sm text-gray-600 border-t">
            <p>Documento gerado pelo sistema Insight NR1 em 13/01/2026</p>
            <p>Este documento faz parte do Programa de Gerenciamento de Riscos (PGR) da empresa</p>
          </div>
        </Card>
      </div>
    </SalviaLayout>
  );
}
